package org.example.willfreightnew.components.sections

import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.silk.components.navigation.Link
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.willfreightnew.HeadlineTextStyle
import org.example.willfreightnew.components.SectionTitle
import org.example.willfreightnew.components.layouts.PageLayoutData
import org.example.willfreightnew.components.models.Section
import org.example.willfreightnew.components.util.Constants.SECTION_WIDTH
import org.example.willfreightnew.pages.HeroContainerStyle
import org.example.willfreightnew.toSitePalette
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import com.varabyte.kobweb.compose.ui.modifiers.color
import org.jetbrains.compose.web.css.percent
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import org.jetbrains.compose.web.css.*
import org.example.willfreightnew.components.models.Contact
import org.example.willfreightnew.components.AddressCard
import org.example.willfreightnew.components.DetailsCard
import org.example.willfreightnew.components.util.Res

@InitRoute
fun initContactPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Contact"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun ContactSection() {
    Box(HeroContainerStyle.toModifier()) {
        Div(HeadlineTextStyle.toAttrs()) {
            Box(
                modifier = Modifier
                    .id(Section.Contact.id)
                    .maxWidth(SECTION_WIDTH.px)
                    .padding(top = 20.px, bottom = 100.px)
                    .backgroundColor(ColorMode.current.toSitePalette().background),
                contentAlignment = Alignment.Center
            ) {
                ContactContent()
            }
        }
    }
}

//@Composable
//fun ContactContentOld() {
//    val breakpoint = rememberBreakpoint()
//    Column(
//        modifier = Modifier
//            .fillMaxWidth()
//            .fillMaxHeight()
//            .margin(top = 15.px),
//        horizontalAlignment = Alignment.CenterHorizontally
//    ) {
//        SectionTitle(
//            modifier = Modifier
//                .fillMaxWidth()
//                .margin(bottom = 20.px)
//                .textAlign(TextAlign.Center),
//            section = Section.Contact,
//            alignment = Alignment.CenterHorizontally
//        )
//
//        Row( ) {
//            SpanText("    Will Freight Services\n" + "\n" + "Unit B4 Antrim Enterprise Agency,  58 Greystone Road, Antrim, BT41 1JZT: 028 9442 9990E: info@willfreight.co.uk\n",
//                Modifier
//                    .color(ColorMode.current.toSitePalette().faintText)
//                    .fontSize(20.px)
//                    .fontWeight(FontWeight.Light)
//                    .margin(top = 40.px))
//        }
//    }
//}

@Composable
fun ContactContent() {
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier
            .margin(top = 15.px)
            ,
        horizontalAlignment = Alignment.End
    ) {


//        Column() {
//            MapEmbed()
//        }

        Column(Modifier
            .color(ColorMode.current.toSitePalette().brand.primary)
            .padding(left = 75.px)
            .fontSize(24.px)
            .margin(right = 100.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SectionTitle(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(bottom = 40.px)
                    .textAlign(TextAlign.Center),
                section = Section.Contact,
                alignment = Alignment.CenterHorizontally
            )
            Row(Modifier
                .fillMaxWidth()
                .fillMaxHeight()
                .margin(right = 200.px),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically) {
                Link(
                    "https://www.google.co.uk/maps/place/Will+Freight+Services+Ltd/@54.7156563,-6.2049839,14.96z/data=!4m6!3m5!1s0x4861ac81ccdf48a3:0x91fc275688b0dd1d!8m2!3d54.717212!4d-6.1810713!16s%2Fg%2F1tfjkk22?entry=ttu&g_ep=EgoyMDI2MDcwNi4wIKXMDSoASAFQAw%3D%3D", Modifier
                        .margin(left = 15.percent)
                ) {
                    /* Block display overrides inline display of the <img> tag, so it calculates centering better */
                    Image(
                        Res.Image.MAP_IMAGE,
                        "Will Freight Address Map",
                        Modifier
                            .height(20.cssRem)
                            .display(DisplayStyle.Block)
                            .displayIfAtLeast(Breakpoint.MD)
                            .padding(all = 5.px)
                            .padding(topBottom = 10.px)
                            .borderRadius(20.px)
                    )
                }
            SimpleGrid(numColumns = numColumns(1)) {
                    DetailsCard(contact = Contact.Details)
                    AddressCard(contact = Contact.Address)
            }
            }
        }
    }
}

//@Composable
//fun MapEmbed(
//    mapSrc: String = "https://maps.google.com/maps?q=Unit%20B4%20Antrim%20Enterprise%20Agency%2C%2058%20Greystone%20Road%2C%20Antrim%2C%20BT41%201JZ&t=m&z=15&ie=UTF8&iwloc=B&output=embed"
//) {
//    Box(
//        Modifier
//            .position(Position.Relative)
//            .padding(bottom = 56.25.percent)
//            .overflow(Overflow.Hidden)
//            .maxWidth(100.percent)
//            .borderRadius(8.px)
//    ) {
//        TagElement<HTMLIFrameElement>(
//            tagName = "iframe",
//            applyAttrs = {
//                attr("src", mapSrc)
//                attr("loading", "lazy")
//                attr("referrerpolicy", "no-referrer-when-downgrade")
//                attr("allowfullscreen", "true")
//                style {
//                    position(Position.Absolute)
//                    top(0.px)
//                    left(0.px)
//                    width(100.percent)
//                    height(100.percent)
//                    property("border", "0")
//                }
//            },
//            content = {}
//        )
//    }
//}